import {
  Box,
  Container,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@material-ui/core";
import React from "react";
import "./RequestQuote.css";
import { makeStyles } from "@material-ui/core/styles";
import AllInclusiveIcon from "@material-ui/icons/AllInclusive";
import Header from "../../Shard/Navbar/Header";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    fontFamily: "Mulish, sans-serif",
    padding: "30px 0",
  },
  requestParentBg: {
    background: "linear-gradient(#f5f5f5, #f8f9f9)",
  },
  requestParent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    flexWrap: "wrap",
    gap: "1rem",
  },
  title: {
    paddingBottom: "15px",
  },
  icon: {
    marginTop: "5px",
  },
  requestQuoteTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
  },
});

const RequestQuoteAfter = ({ isShaw, setIsShaw }) => {
  console.log("RequestQuoteAfter", isShaw);
  const classes = useStyles();
  const [checked, setChecked] = React.useState(true);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  return (
    <>
      <Header isShaw={isShaw} setIsShaw={setIsShaw} />
      <div className="requestQuote1">
        <Container className={classes.root}>
          <Box sx={{ flexGrow: 1 }} className={classes.requestParentBg}>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={6} md={12}>
                <Container>
                  <Box className={classes.requestParent}>
                    <Box>
                      <Box className={classes.title}>
                        <Typography variant="h5">Departure</Typography>
                        <Typography variant="h6">Dubai, U.A.E</Typography>
                      </Box>
                      <Box className={classes.title}>
                        {" "}
                        <Typography variant="h5">Ready to Load </Typography>
                        <Typography variant="h6">30/09/2022</Typography>
                      </Box>
                      <Box className={classes.title}>
                        <Typography variant="h5">Load details</Typography>
                        <Typography variant="h6">86 CBM</Typography>
                      </Box>
                      <Box>
                        <Typography
                          variant="h6"
                          className={classes.requestQuoteTitle}
                        >
                          <span className="ServiceIcon">
                            <AllInclusiveIcon />
                          </span>
                          <span>Associated Service</span>
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Insuracnce"
                        />
                      </Box>
                    </Box>
                    <Box>
                      <Box className="title2">
                        <Typography variant="h5">Arrival </Typography>
                        <Typography variant="h6">
                          Riyadh, Saudi Arabia
                        </Typography>
                      </Box>
                      <Box
                        className={classes.title}
                        style={{ marginBottom: "15px" }}
                      >
                        <Typography variant="h5">Type </Typography>
                        <Typography variant="h6">FTL</Typography>
                      </Box>
                      <Box className="nonePro">
                        <Typography variant="h5"> tt</Typography>
                        <Typography variant="h6">ttt</Typography>
                      </Box>
                      <Box className="nonePro">
                        <Typography variant="h5"> ttt</Typography>
                      </Box>

                      <Box>
                        {" "}
                        <TextField
                          id="outlined-basic"
                          label="AED 50,000"
                          variant="outlined"
                        />
                      </Box>
                    </Box>
                  </Box>
                </Container>
              </Grid>
              <Grid item xs={12} lg={6} md={12}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={6} md={12}>
                <Container>
                  <Box className={classes.requestParent}>
                    <Box>
                      <Box className={classes.title}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Certification"
                        />
                      </Box>
                      <Box className={classes.title}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Inspection Services"
                        />
                      </Box>
                      <Box className={classes.title}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Custom Clearance"
                        />
                      </Box>
                    </Box>
                    <Box>
                      <Box>
                        {" "}
                        <TextField
                          id="outlined-basic"
                          label="AED 70,000"
                          variant="outlined"
                        />
                      </Box>
                    </Box>
                  </Box>
                </Container>
              </Grid>
              <Grid item xs={12} lg={6} md={12}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={6} md={12}>
                <Container>
                  <Box className="">
                    <Box>
                      <Box className={classes.title}>
                        <Typography
                          variant="h6"
                          className={classes.requestQuoteTitle}
                        >
                          <span className="ServiceIcon">
                            <AllInclusiveIcon />
                          </span>
                          <span> Additional requirements</span>
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      style={{
                        display: "flex",
                        columnGap: "20px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box className={classes.title}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="Loading"
                              color="primary"
                            />
                          }
                          label="Loading"
                        />
                      </Box>
                      <Box className={classes.title}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Unloading"
                        />
                      </Box>
                    </Box>
                  </Box>
                </Container>
              </Grid>
              <Grid item xs={12} lg={6} md={12}></Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={6} md={12}>
                <Container>
                  <Box className="">
                    <Box>
                      <Box className={classes.title}>
                        <Typography
                          variant="h6"
                          className={classes.requestQuoteTitle}
                        >
                          <span className="ServiceIcon">
                            <AllInclusiveIcon />
                          </span>
                          <span> Required Equipment</span>
                        </Typography>
                      </Box>
                    </Box>
                    <Box
                      style={{
                        display: "flex",
                        columnGap: "20px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box className={classes.title}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Liftgate"
                        />
                      </Box>
                      <Box className={classes.title}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Pallet Jack"
                        />
                      </Box>
                      <Box className={classes.title}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Load Straps"
                        />
                      </Box>
                    </Box>
                    <Box
                      style={{
                        display: "flex",
                        columnGap: "20px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box className={classes.title}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Load bars"
                        />
                      </Box>
                      <Box className={classes.title}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="TIR Cable"
                        />
                      </Box>
                      <Box className={classes.title}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="SideLoading"
                              color="primary"
                            />
                          }
                          label="Side Loading"
                        />
                      </Box>
                    </Box>
                  </Box>
                </Container>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={8} md={12}>
                <Container>
                  <Box className="">
                    <Box>
                      <Box className={classes.title}>
                        <Typography
                          variant="h6"
                          className={classes.requestQuoteTitle}
                        >
                          <span className="ServiceIcon">
                            <AllInclusiveIcon />
                          </span>
                          <span> Remarks</span>
                        </Typography>
                      </Box>
                      <Box className="request1Input">
                        {" "}
                        <TextField
                          id="outlined-basic"
                          label=""
                          variant="outlined"
                          className="request1Input"
                        />
                      </Box>
                      <Box className="button-sub">
                        <button className="common-btn">Submit</button>
                      </Box>
                    </Box>
                  </Box>
                </Container>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </div>
    </>
  );
};

export default RequestQuoteAfter;
